import {useContext, useMemo} from 'react'
import {CalendarViewContext} from '../../context/CalendarView/CalendarView'

const useViewColor = () => {
  const {viewData} = useContext(CalendarViewContext)
  const color = useMemo(() => {
    const {selectedView, selectedFilteredViews} = viewData
    let c = selectedView?.group_view?.color || '#26d779'
    if (selectedFilteredViews.length === 1) {
      c = selectedFilteredViews[0].color
    }
    return c
  }, [viewData])

  return color
}

export default useViewColor
